module.exports = __webpack_public_path__ + "img/zixun_4.0b75e7a.png";